"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _navigation = require('web/actions/navigation');
var _broadcast = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');

var _EntityNotFoundScreen = require('web/screens/EntityNotFoundScreen'); var _EntityNotFoundScreen2 = _interopRequireDefault(_EntityNotFoundScreen);
var _Spinner = require('web/components/Spinner');
var _CampaignStatus = require('web/screens/Broadcast/CampaignStatus'); var _CampaignStatus2 = _interopRequireDefault(_CampaignStatus);
var _WizardFrame = require('./WizardFrame');
var _Details = require('./Details'); var _Details2 = _interopRequireDefault(_Details);
var _Message = require('./Message'); var _Message2 = _interopRequireDefault(_Message);
var _Recipients = require('./Recipients'); var _Recipients2 = _interopRequireDefault(_Recipients);
var _steps = require('./steps');













/* The campaign wizard, in the Broadcast screen's main pane. A new campaign
 * walks the three steps in order; an existing one opens at the step its entry
 * point asks for, with every step one click away. */
const CampaignWizard = ({
  campaignKey,
  step,
  isCreating: isCreatingProp = false,
  hasLoadFailed = false,
}) => {
  const location = _reactrouterdom.useLocation.call(void 0, )
  const isCreating = !campaignKey || isCreatingProp || location.search.includes(_navigation.CREATING_CAMPAIGN_QUERY)
  const campaign = _hooks.useAppSelector.call(void 0, state => campaignKey ? _broadcast.selectCampaignByKey.call(void 0, state, campaignKey) : null)

  // An unfinished draft's page is this wizard (F4), so leaving the create
  // flow goes back to the campaign list; the draft stays in it.
  const onClose = _react.useCallback.call(void 0, 
    () => campaignKey && !isCreating ? _actions2.default.gotoCampaignPage(campaignKey) : _actions2.default.gotoCampaigns(),
    [campaignKey, isCreating],
  )
  const onGotoStep = _react.useCallback.call(void 0, 
    (s) => campaignKey && _actions2.default.gotoCampaignWizard(campaignKey, s, isCreating),
    [campaignKey, isCreating],
  )

  const onSubmitDetails = _react.useCallback.call(void 0, 
    async (details) => {
      if (!campaign) {
        const created = await _actions2.default.createCampaign({ ...details, MessageTemplate: '' })
        _actions2.default.gotoCampaignWizard(created.CampaignKey, 'recipients', true)
        return
      }
      await _actions2.default.updateCampaign({
        ...details,
        CampaignKey: campaign.CampaignKey,
        MessageTemplate: campaign.MessageTemplate,
      })
      if (isCreating) _actions2.default.gotoCampaignWizard(campaign.CampaignKey, 'recipients', true)
      else _actions2.default.gotoCampaignPage(campaign.CampaignKey)
    },
    [campaign, isCreating],
  )

  const onMessageSaved = _react.useCallback.call(void 0, 
    () => { if (campaignKey) _actions2.default.gotoCampaignPage(campaignKey) },
    [campaignKey],
  )

  if (hasLoadFailed) return _react2.default.createElement(_EntityNotFoundScreen2.default, { desc: "Failed to load campaign"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}} )

  const isImporting = step === 'recipients'

  return (
    _react2.default.createElement('div', { className: "broadcast-wizard", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
      , _react2.default.createElement(_WizardFrame.WizardHeader, {
        title: _optionalChain([campaign, 'optionalAccess', _ => _.Name]) || 'New campaign',
        // Rev 23 W1: the stepper says which step; the subtitle doesn't repeat it.
        // The status reads "Adding recipients · 40%" while an Add runs (P2').
        subtitle: isCreating
          ? campaignKey && _react2.default.createElement(_CampaignStatus2.default, { campaignKey: campaignKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}} )
          : `Editing · ${_steps.stepLabel.call(void 0, step)}`
        ,
        closeLabel: isImporting && !isCreating
          ? 'Exit (nothing is added)'
          : isCreating ? 'Exit (the draft is kept)' : 'Back to campaign'
        ,
        onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      )
      , _react2.default.createElement(_WizardFrame.WizardSteps, {
        current: step,
        isEditing: !isCreating,
        onGotoStep: campaignKey ? onGotoStep : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
      )
      ,  campaignKey && !campaign
        ? _react2.default.createElement('div', { className: "broadcast-wizard--loading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} ))
        : renderStep()
      
    )
  )

  function renderStep () {
    switch (step) {
      case 'details':
        return (
          _react2.default.createElement(_Details2.default, {
            key: _nullishCoalesce(_optionalChain([campaign, 'optionalAccess', _2 => _2.CampaignKey]), () => ( 'new')),
            campaign: campaign,
            isCreating: isCreating,
            onCancel: onClose,
            onSubmit: onSubmitDetails, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
          )
        )
      case 'recipients':
        return (
          _react2.default.createElement(_Recipients2.default, {
            campaign: campaign ,
            onBack: () => onGotoStep('details'),
            onContinue: () => onGotoStep('message'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
          )
        )
      case 'message':
        return (
          _react2.default.createElement(_Message2.default, {
            campaign: campaign ,
            isCreating: isCreating,
            onBack: () => onGotoStep('recipients'),
            onClose: onClose,
            onSaved: onMessageSaved, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
          )
        )
      default:
        return null
    }
  }
}

exports. default = _react.memo.call(void 0, CampaignWizard)
